import { ReactNode, CSSProperties } from "react";
import AppSidebar from "./AppSidebar";
import AppHeader from "./AppHeader";
import { useProfile } from "../../hooks/profile/useProfile";
import { useNav } from "../../context/NavContext";
import { DashboardSkeleton } from "../common/Loader";

export const DashboardLayout = ({ children }: { children: ReactNode }) => {
  const { profile, loading } = useProfile();
  const { sidebarShow } = useNav();

  if (loading && !profile) return <DashboardSkeleton />;

  return (
    <>
      <AppSidebar />
      <div
        className="wrapper d-flex flex-column min-vh-100"
        style={
          {
            "--cui-sidebar-occupy-start": sidebarShow ? "280px" : "0px",
          } as CSSProperties
        }
      >
        <AppHeader profile={profile} />
        {children}
      </div>
    </>
  );
};
